import ErrorWarningIcon from "@/assetsV3/ErrorWarning";
import PickWalletAccordion from "../../Accordion/PickWallet";
import { IGCCHoldings } from "@/types/IGCCHoldings";
import CloseCross from "@/assetsV2/CloseCross";
import PickGccAccordion from "../../Accordion/PickGcc";
import useSolanaTransaction from "@/callbacks/useSolanaTransaction";
import SolanaIcon from "@/assetsV2/Marketplace/SolanaIcon";

type Props = {
    selectedWallet: string;
    setSelectedWallet: (val: string) => void;
    setSelectedGcc: (val: IGCCHoldings) => void;
    selectedGcc: IGCCHoldings | undefined;
    setShowModal: (val: boolean) => void;
    displayAmount: string;
    setDisplayAmount: (val: string) => void;
    displayPrice: string;
    setDisplayPrice: (val: string) => void;
    isEnableWalletSelection: boolean;
};


export default function DetailStep({
    selectedWallet,
    setSelectedWallet,
    setSelectedGcc,
    selectedGcc,
    setShowModal,
    displayAmount,
    setDisplayAmount,
    displayPrice,
    setDisplayPrice,
    isEnableWalletSelection,
}: Props) {
    const { fromLamports } = useSolanaTransaction();

    const remainingAmount = selectedGcc
        ? fromLamports(selectedGcc.tokens) -
        fromLamports(selectedGcc.tokens_onmarket)
        : 0;
    return (
        <div className="flex flex-col p-6 gap-6 w-full bg-outbackground-main opacity-100 rounded-none outmd:rounded-2xl">
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-1">
                    <div className="flex gap-px text-[15px] font-bold tracking-normal leading-5 whitespace-nowrap">
                        <div className="text-outext-main text-[15px] font-bold ">
                            Wallet
                        </div>
                    </div>
                    <PickWalletAccordion
                        selectedWallet={selectedWallet}
                        setSelectedWallet={setSelectedWallet}
                        isEnableWalletSelection={isEnableWalletSelection}
                        isListedScreen={true}
                    />
                </div>
                <div className="flex flex-col  gap-1">
                    <div className="flex gap-px text-[15px] font-bold tracking-normal leading-5 whitespace-nowrap">
                        <div className="text-outext-main text-[15px] font-bold ">
                            Chip
                        </div>
                    </div>
                    <PickGccAccordion
                        setSelectedGcc={setSelectedGcc}
                        selectedGcc={selectedGcc}
                        isEnableWalletSelection={isEnableWalletSelection}
                    />
                </div>
                <div className="flex flex-col relative  gap-1">
                    <div className="flex gap-px text-[15px] font-bold tracking-normal leading-5 whitespace-nowrap">
                        <div className="text-outext-main text-[15px] font-bold ">
                            Chip Amount
                        </div>
                    </div>
                    <div
                        className={`flex h-[46px] justify-between border border-outstate-grayborder text-sm leading-5 rounded-lg focus:bg-outbackground-weak bg-outbackground-main focus:ring-transparent px-[18px] py-3 block w-full !outline-none text-outext-soft`}
                    >
                        <input
                            type="number"
                            className={
                                "bg-transparent !font-medium placeholder:font-medium text-sm placeholder:text-outext-sub  placeholder:text-sm text-outext-main border-none outline-none focus:border-none focus:outline-none"
                            }
                            value={+displayAmount === 0 ? "" : displayAmount}
                            onChange={(e) => {
                                // Only allow integers
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) {
                                    setDisplayAmount(value);
                                }
                            }}
                            placeholder="Enter Amount"
                            step="1" // Disallows decimals
                        />
                        {selectedGcc && +displayAmount >= remainingAmount ? (
                            <></>
                        ) : (
                            // <></>
                            <button
                                onClick={() => {
                                    if (selectedGcc) {
                                        setDisplayAmount(remainingAmount.toString());
                                    }
                                }}
                            >
                                <span className="text-outext-blue text-base font-medium">Max</span>
                            </button>
                        )}
                    </div>
                    <div
                        className={`flex absolute -bottom-[22px] sm:bottom-[-20px] gap-1 py-0.5 mt-1 text-xs leading-4 text-outstate-error ${selectedGcc && +displayAmount > remainingAmount
                            ? ""
                            : "opacity-0"
                            }`}
                    >
                        {selectedGcc ? (
                            remainingAmount === 0 ? (
                                <div className="flex-1">
                                    Insufficient Amount
                                </div>
                            ) : (
                                <div className="flex-1">
                                    You own {remainingAmount} {remainingAmount === 1 ? 'Chip': 'Chips'} only
                                </div>
                            )
                        ) : (
                            <span>Error in amount</span>
                        )}
                    </div>
                </div>
                <div className="flex flex-col gap-1">
                    <div className="flex gap-px text-[15px] font-bold tracking-normal leading-5 whitespace-nowrap">
                        <div className="text-outext-main">Price Per Chip</div>
                    </div>
                    <div
                        className={`border flex border-outstate-grayborder text-sm leading-5 rounded-lg focus:bg-outbackground-weak bg-outbackground-main focus:ring-transparent px-[18px] py-3 w-full !outline-none text-outext-soft`}
                    >
                        <input
                            type="number"
                            className={
                                "bg-transparent flex-1 !font-medium placeholder:font-medium text-sm placeholder:text-outext-sub  placeholder:text-sm text-outext-main border-none outline-none focus:border-none focus:outline-none"
                            }
                            value={displayPrice === "" ? "" : +displayPrice}
                            onChange={(e) => {
                                if (e.target.value !== "") {
                                    setDisplayPrice(Number(e.target.value).toString());
                                } else {
                                    setDisplayPrice("");
                                }
                            }}
                            placeholder="Enter Price"
                        />
                        <SolanaIcon className={+displayPrice <= 0 ? "fill-outext-sub" : 'fill-outext-main'} />
                    </div>
                </div>
            </div>
        </div>
    );
}